import type { UserRole } from "@/types/team";

export function canManageTeam(role: UserRole | null): boolean {
  return role === "owner" || role === "admin";
}

/**
 * Stricter than `canManageTeam` on purpose: tenant-service rejects
 * everyone but the owner on the billing mutations (ADR-029), so admins
 * see billing read-only rather than buttons that would 403.
 */
export function canManageBilling(role: UserRole | null): boolean {
  return role === "owner";
}

/**
 * The roles tenant-service accepts on the alerting writes (rules, the Slack
 * target and its test). Everyone in the workspace can read alerting.
 */
export function canManageAlerts(role: UserRole | null): boolean {
  return role === "owner" || role === "admin";
}
